import * as React from "react";
import { ActivityNavbar } from '../../Shared/index';
import { DropdownObjectInterface } from '../../Staff/interfaces/evidenceInterfaces';

interface HeaderProps {
  isOnMobile?: boolean;
  isTeacher?: boolean;
  language?: string;
  languageOptions?: DropdownObjectInterface[];
  onTogglePreview?: () => void;
  previewShowing?: boolean;
  translate: (language: string) => string;
  updateLanguage?: (language: string) => void;
}

export const Header: React.FC<HeaderProps> = (props) => (
  <ActivityNavbar
    checkTeacherIdentity={true}
    isELLDiagnostic={false}
    isOnMobile={props.isOnMobile}
    isTeacher={props.isTeacher}
    language={props.language}
    languageOptions={props.languageOptions}
    onTogglePreview={props.onTogglePreview}
    previewShowing={props.previewShowing}
    showLanguagePicker={true}
    showTeacherPreview={true}
    toolName="grammar"
    translate={props.translate}
    updateLanguage={props.updateLanguage}
    useShowTranslationsCheck={true}
  />
);
